import React from 'react'
import './Stox.css'
import ButtonArrow from './components/ButtonArrow'

function Stox() {
    return (
        <div id="stox">

                <div id="stox_preview" class="stox fullscreen">
                        <div class="stox flexbox">
                        <div>
                            <h1 class="stox primarytext">Analyze Companies with ease. </h1>
                            <p class="stox secondarytext">Read Annual and Quarterly Reports to stay on top of your investments and understand Businesses better.</p>
                            <br/>
                            <a href="https://forms.gle/91t3SdiAvRb27fhj8" rel="noopener noreferrer">
                                <img class="phone_align" id="stox_preview_app_button" src="assets/img/brands/logomark/apple-app-store.svg" alt="app_store"/>
                            </a>
                        </div>
                        <div>
                            <img class="phone_align" id="stox_preview_phone" src="assets/img/illustrations/xbrl_reader_1.png" alt="stox reader app"></img>
                        </div>
                    </div>
                    <p class="stox minimaltext mobilehide">Discover Stox Reader<br/><ButtonArrow direction="down"/></p>
                </div>
      

            <div id="allcompanies" class="stox fullscreen">
                <div class="stox flexbox">
                    <div>
                        <img class="phone_align" id="stox_allcompanies_brands" src="assets/img/brands/stox_logos.png" alt="companies"></img>
                    </div>
                    <div>
                        <h1 class="stox primarytext white">All US Stocks Available</h1>
                        <br/>
                        <p class="stox secondarytext white">Browse through thousands of Reports and compare Companies</p>
                        <br/>
                        <p class="stox secondarytext white">Stox Reader adapts Reports for Phone, Tablet and Desktop use, and makes Information more presentable.</p>
                    </div>
                </div>
            </div>

            <div id="forbusiness">
                <img class="phone_align" src="assets/img/illustrations/illustration-2.png" alt="business"></img><br/><br/>
                <h1 class="stox primarytext">For Business</h1>
                <p class="stox secondarytext">Include Stox Reader into your Business to improve your Desktop, Web or Mobile Application and provide your Customers with more Information</p>
            </div>
            <div id="foreducation">
                <div class="stox flexbox">
                    <div>
                        <h1 class="stox primarytext">For Educational Institutions</h1>
                        <p class="stox secondarytext">Perfect for Students  to get familiar with 10-K, 10-Q and other SEC Filings</p>
                        <p class="stox secondarytext">Suitable for presentations and demonstrations during Lectures</p>
                    </div>
                    <div>
                        <img class="phone_align" id="foreducation_photo" src="assets/img/photos/stoxeducation.png" alt="education"></img>
                    </div>
                </div>
                <a class="stox contact_us" href="MAILTO:business@deltaparse.com">Contact Us</a>
            </div>
        </div>
      
    )
}

export default Stox
